import { createStructuredSelector } from "reselect";
import {
    USER_ACTIONS_LIST,
    USER_ACTIONS_LIST_SUCCESS,
    USER_ACTIONS_LIST_ERROR,
    USER_LIST,
    USER_LIST_SUCCESS,
    USER_LIST_ERROR,
    USER_LIST_PAGE_SET,
    USER_LIST_HEADER,
    USER_LIST_SEARCH_SET,
    USER_LIST_SEARCH_CHANGE,
    USER_LIST_MODAL_SET,
    USER_LIST_SET_DATA,
    USER_LIST_SET_DATA_UPDATE,
    USER_LIST_UPDATE,
    USER_LIST_UPDATE_SUCCESS,
    USER_LIST_UPDATE_ERROR,
    USER_LIST_TAB_SET,
    USER_LIST_ADD_MODAL_SET,
    USER_LIST_ADD,
    USER_LIST_ADD_SUCCESS,
    USER_LIST_ADD_ERROR,
    USER_LIST_ADD_CHANGE,
    USER_LIST_ADD_SET,
    EXTERNAL_USER_LIST,
    EXTERNAL_USER_LIST_SUCCESS,
    EXTERNAL_USER_LIST_ERROR,
    EXTERNAL_USER_LIST_PAGE_SET,
    EXTERNAL_USER_LIST_HEADER,
    EXTERNAL_USER_LIST_SEARCH_SET,
    EXTERNAL_USER_LIST_SEARCH_CHANGE,
    EXTERNAL_USER_LIST_SET_DATA,
    EXTERNAL_USER_LIST_SET_DATA_UPDATE,
    EXTERNAL_USER_LIST_UPDATE,
    EXTERNAL_USER_LIST_UPDATE_SUCCESS,
    EXTERNAL_USER_LIST_UPDATE_ERROR,
    EXTERNAL_USER_LIST_ADD_MODAL_SET,
    EXTERNAL_USER_LIST_ADD,
    EXTERNAL_USER_LIST_ADD_SUCCESS,
    EXTERNAL_USER_LIST_ADD_ERROR,
    EXTERNAL_USER_LIST_ADD_CHANGE,
    EXTERNAL_USER_LIST_ADD_SET
} from "../actions";

export const NAME = 'user';

export const UserActionsList = ( filters, stateFilter) => ({
    type: USER_ACTIONS_LIST,
    payload: {  filters: filters, filtersState: stateFilter }
});

export const UserActionsListSuccess = (data) => ({
    type: USER_ACTIONS_LIST_SUCCESS,
    payload: data
});

export const UserActionsListError = (error) => ({
    type: USER_ACTIONS_LIST_ERROR,
    payload: error
});

export const UserList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: USER_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const UserListSuccess = (data) => ({
    type: USER_LIST_SUCCESS,
    payload: data
});

export const UserListError = (error) => ({
    type: USER_LIST_ERROR,
    payload: error
});

export const UserListPageSet = (data) => ({
    type: USER_LIST_PAGE_SET,
    payload: data
});

export const UserListHeader = (data) => ({
    type: USER_LIST_HEADER,
    payload: data
})

export const UserListSearchSet = (data) => ({
    type: USER_LIST_SEARCH_SET,
    payload: data
});

export const UserListSearchChangeSet = (data) => ({
    type: USER_LIST_SEARCH_CHANGE,
    payload: data
});

export const UserListModalSet = (data) => ({
    type: USER_LIST_MODAL_SET,
    payload: data
});

export const UserListAddModalSet = (data) => ({
    type: USER_LIST_ADD_MODAL_SET,
    payload: data
});

export const UserListSetData = (data) => ({
    type: USER_LIST_SET_DATA,
    payload: data
});

export const UserListSetDataUpdate = (data) => ({
    type: USER_LIST_SET_DATA_UPDATE,
    payload: data
});

export const UserListUpdate = (data) => ({
    type: USER_LIST_UPDATE,
    payload: data
});

export const UserListUpdateSuccess = (message) => ({
    type: USER_LIST_UPDATE_SUCCESS,
    payload: message
});

export const UserListUpdateError = (error) => ({
    type: USER_LIST_UPDATE_ERROR,
    payload: error
});

export const UserListTabSet = (data) => ({
    type: USER_LIST_TAB_SET,
    payload: data
});

export const UserListAdd = (data) => ({
    type: USER_LIST_ADD,
    payload: data
});

export const UserListAddSuccess = (message) => ({
    type: USER_LIST_ADD_SUCCESS,
    payload: message
});

export const UserListAddError = (error) => ({
    type: USER_LIST_ADD_ERROR,
    payload: error
});

export const UserListAddChangeSet = (data) => ({
    type: USER_LIST_ADD_CHANGE,
    payload: data
});

export const UserListAddSet = (data) => ({
    type: USER_LIST_ADD_SET,
    payload: data
});


export const ExternalUserList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: EXTERNAL_USER_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const ExternalUserListSuccess = (data) => ({
    type: EXTERNAL_USER_LIST_SUCCESS,
    payload: data
});

export const ExternalUserListError = (error) => ({
    type: EXTERNAL_USER_LIST_ERROR,
    payload: error
});

export const ExternalUserListPageSet = (data) => ({
    type: EXTERNAL_USER_LIST_PAGE_SET,
    payload: data
});

export const ExternalUserListHeader = (data) => ({
    type: EXTERNAL_USER_LIST_HEADER,
    payload: data
})

export const ExternalUserListSearchSet = (data) => ({
    type: EXTERNAL_USER_LIST_SEARCH_SET,
    payload: data
});

export const ExternalUserListSearchChangeSet = (data) => ({
    type: EXTERNAL_USER_LIST_SEARCH_CHANGE,
    payload: data
});

export const ExternalUserListModalSet = (data) => ({
    type: EXTERNAL_USER_LIST_MODAL_SET,
    payload: data
});

export const ExternalUserListAddModalSet = (data) => ({
    type: EXTERNAL_USER_LIST_ADD_MODAL_SET,
    payload: data
});

export const ExternalUserListSetData = (data) => ({
    type: EXTERNAL_USER_LIST_SET_DATA,
    payload: data
});

export const ExternalUserListSetDataUpdate = (data) => ({
    type: EXTERNAL_USER_LIST_SET_DATA_UPDATE,
    payload: data
});

export const ExternalUserListUpdate = (data) => ({
    type: EXTERNAL_USER_LIST_UPDATE,
    payload: data
});

export const ExternalUserListUpdateSuccess = (message) => ({
    type: EXTERNAL_USER_LIST_UPDATE_SUCCESS,
    payload: message
});

export const ExternalUserListUpdateError = (error) => ({
    type: EXTERNAL_USER_LIST_UPDATE_ERROR,
    payload: error
});

export const ExternalUserListAdd = (data) => ({
    type: EXTERNAL_USER_LIST_ADD,
    payload: data
});

export const ExternalUserListAddSuccess = (message) => ({
    type: EXTERNAL_USER_LIST_ADD_SUCCESS,
    payload: message
});

export const ExternalUserListAddError = (error) => ({
    type: EXTERNAL_USER_LIST_ADD_ERROR,
    payload: error
});

export const ExternalUserListAddChangeSet = (data) => ({
    type: EXTERNAL_USER_LIST_ADD_CHANGE,
    payload: data
});

export const ExternalUserListAddSet = (data) => ({
    type: EXTERNAL_USER_LIST_ADD_SET,
    payload: data
});

const user = (state) => state[NAME];

export const UserSelector = createStructuredSelector({
    user
})
